import { match } from 'ts-pattern'
import { z } from 'zod'

export const searchBillingPlanSchema = z
  .object({
    plan_details: z
      .object({
        max_searches: z.number().optional(),
        seats: z.number().optional(),
        monthly_minimum: z.number().optional(),
      })
      .optional(),
    plan_type: z
      .enum([
        'unlimited',
        'firm_wide_unlimited',
        'bundle',
        'per_search',
        'trial',
        'subscription',
      ])
      .optional(),
    start_date: z.coerce.date().optional(),
    end_date: z.coerce.date().nullable().optional(),
    cost_per_search: z.number().optional(),
  })
  .transform((data) => {
    const {
      plan_details,
      plan_type,
      start_date,
      end_date,
      cost_per_search,
      ...rest
    } = data
    return {
      ...rest,
      startDate: start_date,
      endDate: end_date,
      planType: match(plan_type)
        .with('unlimited', () => 'Unlimited')
        .with('firm_wide_unlimited', () => 'Unlimited')
        .with('bundle', () => 'Bundle')
        .with('per_search', () => 'Per search')
        .with('trial', () => 'Trial')
        .with('subscription', () => 'Subscription')
        .otherwise(() => 'Unknown'),
      costPerSearch: cost_per_search,
      planDetails: {
        maxSearches: plan_details?.max_searches,
        monthlyMinimum: plan_details?.monthly_minimum,
        seats: plan_details?.seats,
      },
      subscription: plan_type === 'subscription',
      unlimited: plan_type === 'unlimited',
    }
  })
  .optional()
  .nullable()
  .describe('Search Billing Plan')

export type SearchBillingPlanType = z.infer<typeof searchBillingPlanSchema>
